import React from 'react';
import PropTypes from 'prop-types';

const SrListingCardLoader = ({ className }) => (
  <div className={`SrListingCardLoader ${className || ''}`}>
    <div className="animated-background">
      <div className="background-masker price-above" />
      <div className="background-masker price-left" />
      <div className="background-masker price-middle" />
      <div className="background-masker price-right" />
      <div className="background-masker time-above" />
      <div className="background-masker price-bed-spacer" />
      <div className="background-masker bed-left" />
      <div className="background-masker bed-right" />
      <div className="background-masker bed-below" />
    </div>
  </div>
);

SrListingCardLoader.propTypes = {
  className: PropTypes.string,
};

export default SrListingCardLoader;
